import {Stack, SvgIconTypeMap} from "@mui/material";
import React, {useMemo} from "react";
import {useEmployeeMapStore} from "../../api/EmployeeMapStore";
import EmployeeAvatar from "../employee-avatar/EmployeeAvatar";
import EmployeeLink from "../employee-link/EmployeeLink";
import {useRemoteValue} from "../../util/RemoteValue";
import ScalingSpacesIcon from "../icons/ScalingSpacesIcon";
import {capitalize} from "../../util/StringUtil";
import {OverridableComponent} from "@mui/material/OverridableComponent";

function getKnownPrincipal(principalEmail: string): {
    icon: OverridableComponent<SvgIconTypeMap>,
    name: string,
} | undefined {
    const indexOfScaling = principalEmail.toLowerCase().indexOf("@scalingspaces.com");
    if (indexOfScaling >= 0) {
        return {
            icon: ScalingSpacesIcon,
            name: principalEmail
                .substring(0, indexOfScaling)
                .split('.')
                .map(part => capitalize(part.toLowerCase()))
                .join(' ')
        }
    }
    return undefined;
}

export function Principal({principalEmail}: {
    principalEmail: string,
}) {
    const employeeMap = useEmployeeMapStore(state => state.remoteValue);
    const employeeRV = useMemo(() =>
            employeeMap.map(employeeMap =>
                employeeMap.getByEmail(principalEmail)
            ),
        [employeeMap, principalEmail],
    );

    const employee = useRemoteValue(employeeRV, undefined);

    const knownPrincipal = useMemo(
        () => getKnownPrincipal(principalEmail),
        [principalEmail],
    );

    return (
        employee ? (
            <Stack direction="row" gap={1} alignItems="center">
                <EmployeeAvatar employee={employee} sx={{width: 24, height: 24}}/>
                <EmployeeLink employee={employee} sx={{fontSize: 'inherit', color: 'inherit'}}/>
            </Stack>
        ) : knownPrincipal ? (
            <Stack direction="row" gap={1} alignItems="center">
                <knownPrincipal.icon sx={{width: 24, height: 24}}/>
                {knownPrincipal.name}
            </Stack>
        ) : (
            <>
                {principalEmail}
            </>
        )
    );
}
